export const OFFER_DISPLAY_NAMES = {
    initial: "Étude encadrée",
    essential: "Cours Partagés",
    integral: "Cours particuliers",
    autonomy: "Offre Autonomie",
}

export const getOfferDisplayName = (code) => OFFER_DISPLAY_NAMES[code] ?? code

export const getOfferTypeOptions = () => [
    { label: OFFER_DISPLAY_NAMES.initial, value: "initial" },
    { label: OFFER_DISPLAY_NAMES.essential, value: "essential" },
    { label: OFFER_DISPLAY_NAMES.integral, value: "integral" },
    { label: OFFER_DISPLAY_NAMES.autonomy, value: "autonomy" },
]

export const HOURS_PER_MONTH_TO_WEEK = {
    4: 1,
    6: 1.5,
    9: 2,
    13: 3,
    17: 4,
    22: 5,
}
